import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getUlHtml = ((node: Block | Inline, next: Next) =>
  `<ul>${next(node.content)} </ul>`) as NodeRenderer;
